/*
 *
 * AdministratorBCForm
 *
 */

import React from 'react';
import AdvancedForm from 'containers/AdvancedForm';
import {TENANT_ANNOUNCEMENT_FORM} from "./constants";
import {formField} from "domain/typeConstants/form";


export class TenantForm extends React.PureComponent {
    getFields() {
        return [
            {
                name: 'creationDate',
                label: 'Дата',
                type: formField.DATE,
            },
            {
                name: 'name',
                label: 'Наименование',
                grid: {sm: 12},
            },
            {
                name: 'content',
                label: 'Содержание',
                type: formField.EDITOR,
                grid: {sm: 12},
            },
            {
                name: 'file',
                label: 'Фото',
                type: formField.FILE,
                helperText: () => 'Прикрепите файл',
                grid: {sm: 6},
                previewImage: true,
                fileSize: {
                    size: 10e6,
                    errorTextFile: 'Размер прикрепляемого файла не должен превышать 10 Мб'
                },
            },

        ];
    }

    getClassNames() {
        return {
            helperText: '',
        };
    }

    render() {
        return (
            <AdvancedForm
                name={TENANT_ANNOUNCEMENT_FORM}
                entityName={"announcements"}
                fields={this.getFields()}
                classNames={this.getClassNames()}
                {...this.props}
            />
        );
    }
}
